import React, { useMemo } from 'react'
import generalController from '../../../controllers/generalController'
import { stripHTML, convertCurrency } from '../../../utils/helpers';
import Image from '../../1_Atoms/Image/Image';
import FindADealer from '../../3_Organisms/FindADealer/FindADealer'
import ReactHtmlParser from 'react-html-parser';

interface VehicleVisual {
  static_content_base_path: string;
  jelly_path: string;
  jelly: string;
}

interface VehicleData {
  title?: string;
  description?: string;
  msrp?: number;
  visual?: VehicleVisual;
  isEV?: boolean;
  isModelPreOrder?: boolean;
}

interface UserLocation {
  lat: number;
  lng: number;
}

interface PreDefinedDealer {
  dealer_code: string;
  name?: string;
  address_line_1?: string;
  city?: string;
  post_code?: string;
  [key: string]: any;
}

interface DealerSelectionData {
  dealer: any;
  userPosition?: UserLocation;
}

interface FindDealerStepProps {
  handleNextStep: (data: { dealerData: DealerSelectionData }) => void;
  vehicleData?: VehicleData;
  isTopSectionHidden?: boolean;
  isEmbeddedOnBnP?: boolean;
  title?: string;
  subTitle?: string;
  onlyEVDealers?: boolean;
  preDefinedUserLocation?: UserLocation;
  preDefinedDealerData?: PreDefinedDealer;
  dealerId?: string;
  currentStep?: number;
  startingAt?: string;
  displayPrice?: boolean;
  isPreorderModal?: boolean;
}

const FindDealerStep: React.FC<FindDealerStepProps> = ({
  handleNextStep,
  vehicleData,
  isTopSectionHidden = false,
  isEmbeddedOnBnP = false,
  title = '',
  subTitle = '',
  onlyEVDealers = false,
  preDefinedUserLocation,
  preDefinedDealerData,
  dealerId,
  currentStep,
  startingAt,
  displayPrice = true,
  isPreorderModal = false
}) => {
	const language = generalController.detectLanguage();

  // TRUE if the selected vehicle is an EV vehicle OR onlyEVDealers is true.
  const isEvOnly = (onlyEVDealers ? onlyEVDealers : (
    vehicleData && vehicleData.isEV ? vehicleData.isEV : false
  ));

  // Generate an image path for jelly.
  const generateImageSrc = (vehicleData: VehicleData | undefined): string => {
    if (!vehicleData || !vehicleData.visual) return '';
    const { static_content_base_path, jelly_path, jelly } = vehicleData.visual;
    return static_content_base_path + jelly_path + jelly;
  }

  const { title: vehicleTitle, description, msrp } = vehicleData || {};
  
  React.useEffect(() => {
    console.log('refreshing with dealerId', dealerId);
  }, [dealerId, preDefinedDealerData]);

  return (
    <div className="mz-find-dealer-step">
      {
        !isTopSectionHidden && (
          <div className="mz-find-dealer-step__top">
            <div className="mz-container">
              <div className="mz-full-width">
                <h4 className="mz-find-dealer-step__title">{title}</h4>
                {
                  vehicleData &&(
                    <div className="mz-find-dealer-step__vehicle">
                      {!isPreorderModal && 
                        <Image
                          src={generateImageSrc(vehicleData)}
                          alt={vehicleTitle || ''}
                          isLazy={false}
                        />
                      }
                      <div className="mz-find-dealer-step__vehicle-bottom">
                        <h5>{ReactHtmlParser(vehicleTitle || '')}</h5>
                        {displayPrice ? 
                        <p className="m-0">
                           {description ? stripHTML(description) : ''}  {startingAt} {msrp ? convertCurrency(msrp, language) : ''}</p> : null}
                      </div>
                    </div>
                  )
                }
                <h5 className="mz-find-dealer-step__sub-title">{subTitle}</h5>
              </div>
            </div>
          </div>
        )
      }
      <FindADealer
        isStepRenderType={true}
        onSelectDealer={(data: DealerSelectionData) => handleNextStep({ dealerData: data })}
        isEVonly={isEvOnly}
        isEmbeddedOnBnP={isEmbeddedOnBnP}
        preDefinedUserLocation={preDefinedUserLocation}
        preDefinedDealerId={preDefinedDealerData?.dealer_code}
        dealerId={dealerId}
        language={language}
        isModelPreOrder={vehicleData?.isModelPreOrder}
        formExtraParams={{}}
      />
    </div >
  )
}

export default FindDealerStep
